import { IoMdStar } from 'react-icons/io'

interface RatingProps {
  value: number
  showStar?: boolean
}

export function Rating({ value, showStar = true }: RatingProps) {
  return (
    <div className="flex items-center gap-1">
      {showStar && <IoMdStar className="w-3.5 h-3.5 text-yellow-400" />}
      <span className="text-sm text-gray-900">{value.toFixed(2)}</span>
    </div>
  )
}
